import module from './how-we-calculate-score';

export default module;
